// extracted by mini-css-extract-plugin
export default {"PartnerImagesDiv":"PartnerImages_PartnerImagesDiv__ch7pL"};